export default __webpack_public_path__ + "static/media/tituloEN.6c662cae.png";